import React from 'react';
import { Container, Button } from 'reactstrap';
import { useAPIContext } from '../../../utilities/Contexts/DCGAutomationPagesContextProvider';

const Level3ConfirmationPageContent = () => {
    const { navigateToPage } = useAPIContext();
    return (
        <Container className="text-center">
            <p style={{ fontSize: '0.85rem' }}>
                Level 3 permissions gives all DateCodeGenie Managers and Users full access to make changes to the data in your portal and app.
            </p>
            <Button onClick={() => navigateToPage('personaAccountRegistrationPage')} color="primary">CONFIRM</Button>
        </Container>
    )
};
export default Level3ConfirmationPageContent;